import { merchantAdminApi } from '@services';
import { selectAuthenticatedUser, selectCurrentMerchantId } from './authSlice';
import type { AppDispatch, RootState } from '../../../app/store';
import AuthUtils from './auth-utils';

const manageMfaThunk = () => async (dispatch: AppDispatch, getState: () => RootState) => {
    const user = selectAuthenticatedUser(getState());
    const merchantId = selectCurrentMerchantId(getState());

    const result = dispatch(merchantAdminApi.endpoints.merchantUsersControllerRetrieveUserAuthenticatorsSelfManageUrl.initiate({
        userId: user?.userId ?? '',
        merchantId: merchantId ?? -1,
        redirectUrl: window.location.href,
    }));
    result.unsubscribe();
    const response = await result;
    const url = response.data;
    if (!url) {
        return;
    }

    AuthUtils.launchAuthsignal(url);
};

export default manageMfaThunk;
